import React, { useState, useContext, Fragment } from "react";
import Buttons from "../../../lib/ui/buttons/Button";
import "../../../ui-styles/contentHeading/cancelHeading.css";
import RejectConfirmSlide from "./RejectConfirmSlide";
import ConfirmationMsg from "./ConfermationMsg";
import Loader from "../../../lib/ui/loader/Loader";
import { LangCtx, SignalerCtx } from "../../../lib/context";
import { changeApptStatus } from "../../../actions/schedule";
import { cancelAppt, sendInviteLink } from "../../../actions/appointment";
import { timeFormat } from "../../../lib/functions";
import ConfirmCancellation from "../../../lib/ui/confirmCancellation";
import PrescriptionSlide from "../../conference/components/PrescriptionSlide";
import { toast } from "react-toastify";
// import InternalNote from "../../conference/components/internalNote";
// import PatientHistory from "../../conference/components/patientHistory";

const AppointmentItem = (props) => {
    const { l } = useContext(LangCtx);
    const { signaler } = useContext(SignalerCtx);
    // const [visitDetails, setVisitDetails] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [reject, setReject] = useState(false);
    const { data, type, handleSlideData,handleUploads } = props;
    // const [uploads, setUploads] = useState(false);
    const [openCfm, setCfm] = useState(false);
    const [docPscptn, setDocPscptn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hover, setHover] = useState(false);
    // const [notes, setNotes] = useState(false)
    // const [iconsState, setIconsState] = useState({ patientHistory: false });
    // const handleUploads = () => {
    //     setUploads(true);
    // };
    // const handleClose = () => {
    //     setUploads(false);
    // };

    // const handleDetails = (data) => {
    //     setSlideData(data);
    //     setVisitDetails((prevState) => !prevState);
    //     setDocPscptn(false);
    // };

    // const handlePatientHistory = () => {
    //     setIconsState({ patientHistory: !iconsState.patientHistory });
    // };

    const sendInvitations = async (appointmentData) => {
        try { 
                let body = {
                    email : appointmentData.invitedEmail,
                    fname: appointmentData && appointmentData.doctorData ? appointmentData.doctorData.name : '',
                    lname: appointmentData && appointmentData.doctorData && appointmentData.doctorData.lname ? appointmentData.doctorData.lname : '',
                    link: `${origin}/guest-settings/${appointmentData.appointmentId}`,  
                    startTime: appointmentData && appointmentData.startTime ? appointmentData.startTime : new Date().valueOf(),
                    endTime: appointmentData && appointmentData.endTime ? appointmentData.endTime : new Date().valueOf()        
                };
    
                sendInviteLink(body).then(res => {
                    // console.log("guest Mail--------", res);
                }).catch(err => {
                    console.log("guest Mail errr--------", err);
                })

        } catch (err) {
            console.error("Error sending invitations:", err);
        }
        };

    const handleOpen = () => {
        setReject((prevState) => !prevState);
    };

    const handleConfirm = () => {
        if (!loading) {
            setLoading(true);
            changeApptStatus(data.appointmentId, "confirmed")
                .then(async (res) => {
                    // const createSession = await createSessionInAPi(data.appointmentId);
                    props.updateWrCount();
                    if (signaler) {
                        signaler.renderAppoints(data.patientId, "APPTSTATUS", null);
                    }
                    setLoading(false);
                    setConfirm((prevState) => !prevState);
                    
                    if (res  && res.status && res.data.appointmentId && res.data.invitedEmail) {
                        sendInvitations(res.data);
                    }

                    props.loadData();
                })
                .catch((err) => {
                    console.log("err === ", err);
                    let msg = err?.reponse?.data?.error
                        ? err.reponse.data.error
                        : err.errorMessage
                        ? err.errorMessage
                        : l.went_worng_pls_try_again;
                    toast.dismiss();
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                });
        }
    };

    const onMouseHover = () => {
        setHover(true);
    };

    const onMouseOut = () => {
        setHover(false);
    };

    const handleReject = () => {
        if (!loading) {
            setLoading(true);
            changeApptStatus(data.appointmentId, "rejected", data.paymentIntentId, data.clinicId)
                .then((res) => {
                    if (signaler) {
                        signaler.renderAppoints(data.patientId, "APPTSTATUS", null);
                    }
                    setReject((prevState) => !prevState);
                    props.loadData();
                    setLoading(false);
                })
                .catch((err) => {
                    console.log("err === ", err);
                    let msg = err?.reponse?.data?.error
                        ? err.reponse.data.error
                        : err.errorMessage
                        ? err.errorMessage
                        : l.went_worng_pls_try_again;

                    toast.dismiss();
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                });
        }
    };

    const handleCancel = () => {
        setCfm(true);
    };
    const handlePriscription = () => {
        setDocPscptn((prevState) => !prevState);
    };
    const handleClosePriscription = () => {
        setDocPscptn(false);
    };

    const handleCancelConfirm = () => {
        let obj = {
            id: data.appointmentId,
            type: "doctor",
            clinicId: data.clinicId,
            payment_intent: data.paymentIntentId,
        };
        setLoading(true);
        cancelAppt(obj)
            .then((res) => {
                setCfm(false);
                props.loadData();
                setLoading(false);
            })
            .catch((err) => {
                console.log("err ==== ", err);
                setLoading(false);
            });
    };

    return (
        <div className="cardItem cardWidth" key={data.appointmentId}>
            <div className="cardBox">
                {loading && <Loader />}
                {confirm && <ConfirmationMsg />}
                <div className="cardBdy">
                    <div
                        className={
                            data.appt_status === "confirmed"
                                ? "cnclHndRow"
                                : data.appt_status === "rejected" || data.appt_status === "cancelled"
                                ? "cnclCrossIcon"
                                : "pendingIcon"
                        }
                    >
                        <span
                            className={
                                data.appt_status === "confirmed" ? "successTxt" : data.appt_status === "pending" ? "pendingTxt" : "redTxt"
                            }
                        >
                            {l[data.appt_status]}
                        </span>
                    </div>
                    <div className="cardRowBlock flex0">
                        <div className="cardAvatar">
                            <img
                                src={
                                    data.patientData && data.patientData.profileImage && data.patientData.profileImage.url
                                        ? data.patientData.profileImage.url
                                        : "/images/icons/patient-default.png"
                                }
                                alt="avatarimg"
                            />
                        </div>
                        <div className="cardContent">
                            <span className="cardTxtLg">
                                {data.patientData.title ? data.patientData.title : ""}
                                {data.patientData.name}
                            </span>
                            <span className="cardTxtSm">
                                <small className="capitalizeTxt">{data.patientData.gender}</small>
                            </span>
                            {/* {patient.age} {l.years} */}
                            <span className="cardTxtSm boldTxt">
                                {timeFormat(data.startTime)} - {timeFormat(data.endTime)}
                            </span>
                        </div>
                    </div>
                    <div className="cardRowBlock">
                        <span className="cardTxtSm">
                            <small>{l.reason}: </small> {l[data.reason]}
                        </span>
                    </div>
                    <div className="paymentStatusBox">
                        {/* <span className="paymentStatusLTxt">{l.payment_status} :</span>
                            <div className="paymentStatusIcon">
                                <span className="statusCircle statusPaid"></span>
                                <span className="statusInfoTxt paidTxt">{l[data.paymentStatus]}</span>
                            </div> */}

                        {/* <span className="paymentStatusLTxt">{l.payment_status} :</span>
                            <div className="paymentStatusIcon">
                                <span className="statusCircle statusPending"></span>
                                <span className="statusInfoTxt pendingTxt">{l[data.paymentStatus]}</span>
                            </div> */}
                        {data?.paymentMode === "prePaid" && (
                            <>
                                <span className="paymentStatusLTxt">{l.payment_status} :</span>
                                <div className="paymentStatusIcon">
                                    {data?.paymentStatus === "paid" ? (
                                        <>
                                            {" "}
                                            <span className="statusCircle statusPaid"></span>
                                            <span className="statusInfoTxt paidTxt">{l[data.paymentStatus]}</span>
                                        </>
                                    ) : data?.paymentStatus === "open" ||
                                      data?.paymentStatus === "draft" ||
                                      data?.paymentStatus === "initiated" ||
                                      data?.paymentStatus === "pending" ? (
                                        <>
                                            {" "}
                                            <span className="statusCircle statusPending"></span>
                                            <span className="statusInfoTxt pendingTxt">{l[data?.paymentStatus]}</span>
                                        </>
                                    ) : data?.paymentStatus === "uncollectible" ||
                                      data?.paymentStatus === "void" ||
                                      data?.paymentStatus === "failed" ? (
                                        <>
                                            {" "}
                                            <span className="statusCircle statusFailed"></span>
                                            <span className="statusInfoTxt failedTxt" onMouseEnter={onMouseHover} onMouseLeave={onMouseOut}>
                                                {l[data?.paymentStatus]}
                                            </span>
                                            {/* <span className="statusInfoTxt failedTxt" tooltip = {data.failure_reason  ? data.failure_reason : ""}>{ l[data.paymentStatus]}</span> */}
                                        </>
                                    ) : null}
                                    {/*  PAyment Refunded Status ********/}
                                    {/* <>
                                 {" "}
                                 <span className="statusCircle"><img src="/images/icons/refund-green.png" alt="icon" /></span>
                                 <span className="statusInfoTxt paidTxt">{l.refunded}</span>
                                </> */}
                                </div>
                            </>
                        )}

                        {data && data?.failure_reason && (
                            <div className="annotationTxt">
                                <p>{data?.failure_reason}</p>
                            </div>
                        )}
                    </div>
                    <div>
                        {(data?.paymentMode === "free" || data?.paymentMode === "postPaid") && (
                            <>
                                <span className="paymentStatusLTxt">Payment Mode : </span>
                                <span className="statusInfoTxt paidTxt">
                                    {data?.paymentMode && (data?.paymentMode === "free" ? "Free" : "Post Paid")}
                                </span>
                            </>
                        )}
                    </div>
                </div>
                <div className="cardFtr">
                    <div className="dtlsBox" onClick={() => handleSlideData(data)}>
                        <img src="/images/icons/visit-details-outline.png" alt="icon" className="invertPrimary" />
                        <span className="dtlsTxt">{l.visitinfo}</span>
                    </div>
                    {/* <div className="dtlsBox" onClick={handlePatientHistory}>
                        <img src="/images/icons/visit-details-outline.png" alt="icon" className="invertPrimary" />
                        <span className="dtlsTxt">History</span>
                    </div> */}
                    {/* <div className="dtlsBox">
                        <span className={data.appt_status === "confirmed" ? "successTxt" : data.appt_status === "pending" ? "pendingTxt" : "redTxt"}>{l[data.appt_status]}</span>
                    </div> */}
                    <div className="dtlsBoxAction">
                        {type === "PEA" &&
                            (data.paymentStatus === "paid" || data?.paymentMode === "free" || data?.paymentMode === "postPaid") && (
                                <Fragment>
                                    <Buttons label={l.reject} size="sm" type="outLine" onClick={handleOpen} />
                                    <Buttons label={l.confirm} size="sm" type="primary" onClick={handleConfirm} />
                                </Fragment>
                            )}
                        {(type === "PA" || type === "UA") && data.uploads && data.uploads.length > 0 && (
                            <Buttons label={l.pat_uploads} size="sm" type="outLine" onClick={() => handleUploads(data)} />
                        )}
                        {type === "UA" && data.appt_status !== "cancelled" && data.startTime > new Date().valueOf() && (
                            <Buttons label={l.cancel} size="sm" type="outLine" onClick={handleCancel} />
                        )}
                        {/* {(type === "PA") && <Buttons
                            label={l.pat_uploads}
                            size="sm"
                            type="outLine"
                            onClick={() => handleUploads(data)}
                        />} */}
                        {data && data.prescription_status && data.prescription_status === true && (
                            <Buttons label={l.presc} size="sm" type="outLine" onClick={handlePriscription} />
                        )}
                    </div>
                </div>
            </div>
            {/* {visitDetails && <VisitDetailsSlide visitDetails={visitDetails} handleDetails={handleDetails} data={data} />} */}
            {/* {notes && <InternalNote inNotes={notes} close={handleNotes} data={data} />} */}
            {/* {iconsState?.patientHistory && (
                <PatientHistory patientHistory={iconsState?.patientHistory} close={handlePatientHistory} data={data} />
            )} */}
            {reject && <RejectConfirmSlide reject={reject} handleClose={handleOpen} handleReject={handleReject} />}
            {/* {uploads && <PatientUploadsSlide open={uploads} close={handleClose} data={data.uploads} />} */}
            {/* {openCfm && (
                <BtmDeleteSlide
                    slideD={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleCancelConfirm}
                />
            )} */}
            {openCfm && (
                <ConfirmCancellation
                    slideD={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleCancelConfirm}
                />
            )}
            {/* <RefundConf slideD={openCfm} handleCancel={() => setCfm(false)} txt={l.conf_cancel_appt} oktxt={l.cancel_appt} handleConfirm={handleCancelConfirm} /> */}
            {docPscptn && <PrescriptionSlide type="view" openSlide={docPscptn} closePresc={handleClosePriscription} data={data} />}
        </div>
    );
};

export default React.memo(AppointmentItem);
